import { createPage, createFlow } from '../utils';
import { MALE } from '../../gender';
import i18n from '../../../plugins/i18n';
import { REPEAT } from '../variables';
import { LEAD_LOCATIONS } from '../../locations';

const RegisterIntroduce = createPage({
  name: 'RegisterIntroduce',
  nextPage: 'RegisterComplete',
  options: {
    pageConfig: {
      isEmailOptional: true,
      showGender: false,
      showEmail: false,
      patientData: {
        gender: MALE,
      },
    },
  },
});

const RegisterComplete = createPage({
  name: 'RegisterComplete',
  nextPage: 'RegisterFileUpload',
  options: {
    pageConfig: {
      init: (store) => {
        store.commit('setRegistration', {
          appointmentReasons: 'Low Testosterone',
        });
        store.commit('setPatientData', {
          billingAddress: {
            country: 'Canada',
            province: 'Ontario',
          },
          mailingAddress: {
            country: 'Canada',
            province: 'Ontario',
          },
        });
        store.commit('addOtherPatientNote', {
          newNoteText: 'Low Testosterone',
          noteTags: ['Primary Complaint'],
        });
      },
      buttonText: i18n.t('main.continue'),
      cardText: i18n.t('registration.registerComplete.trt.cardText'),
      cardTitle: i18n.t('registration.registerComplete.trt.cardTitle'),
      clickToContinue: false,
      isEndOfRegistration: false,
    },
  },
});

const RegisterFileUpload = createPage({
  name: 'RegisterFileUpload',
  nextPage: 'RegisterLogout',
  options: {
    clearHistory: true,
    pageConfig: {
      isEndOfRegistration: true,
      // TODO: Replace ids with actual pharmacy ids
      leadLocations: LEAD_LOCATIONS,
    },
  },
});

const RegisterLogout = createPage({
  name: 'RegisterLogout',
  nextPage: REPEAT,
  options: { clearHistory: true },
});

const trt = createFlow({
  landing: 'RegisterIntroduce',
  onError: 'RegisterIntroduce',
  flow: {
    RegisterIntroduce,
    RegisterComplete,
    RegisterFileUpload,
    RegisterLogout,
  },
});

export default trt;
